import React, { useState, useRef } from 'react';
import styles from './InfoBlock.module.css';

import img1 from '../../assets/img/registration/1.jpg';
import img2 from '../../assets/img/registration/2.jpg';
import img3 from '../../assets/img/registration/3.jpg';

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  return (
    <div className={`${styles.accordion_item} ${isOpen ? styles.open : ''}`}>
      <button className={styles.accordion_header} onClick={() => setIsOpen(!isOpen)}>
        {title}
        <span className={styles.arrow}>{isOpen ? '−' : '+'}</span>
      </button>
      <div
        className={styles.accordion_content}
        ref={contentRef}
        style={{
          maxHeight: isOpen ? contentRef.current.scrollHeight : 0,
        }}>
        <div className={styles.content_inner}>{content}</div>
      </div>
    </div>
  );
};

export default function InfoBlock() {
  return (
    <section id="6" className={styles.container}>
      <div className={styles.title}>Відповіді на питання?</div>

      <div className={styles.accordion}>
        <AccordionItem
          title="Чи однакове меню для всіх?"
          content="Ні. Калорійність меню перераховується під кожну учасницю. У розрахунок беру вашу
                вагу, зріст, вік та рівень фізичної активності. Тобто, навіть якщо страва та сама,
                її порція буде відповідати саме вашій нормі."
        />
        <AccordionItem
          title="Як зареєструватись в програмі?"
          content={
            <>
              <div>
                1.Перейдіть на{' '}
                <a
                  href="https://app.nk.vinnica.ua"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link_text}>
                  app.nk.vinnica.ua
                </a>
              </div>
              <div>
                2.Натисніть на текст <span className="fw_600">«Зареєструватися»</span>
              </div>
              <div>
                <img className={styles.img} src={img1} />
              </div>
              <div>3.Заповніть всі поля реєстрації</div>
              <div>
                <img className={styles.img} src={img2} />
              </div>
              <div>
                <span className="fw_600">ID Групи:</span> Пишете ID Групи (берем його в групі
                телеграм)
              </div>
              <div>
                <img className={styles.img} src={img3} />
              </div>
              <div>
                <span className="fw_600">Ім'я: </span>Пишете своє ім’я
              </div>
              <div>
                <span className="fw_600">Прізвище: </span>Пишете своє прізвище
              </div>
              <div className="mb_20">
                <span className="fw_600">Телефон: </span> Пишете свій номер телефону у форматі
                <span className="fw_600"> 380968513108</span> (без плюса та пробілів)
              </div>
              <div>
                Після заповнненя всіх полів натискаємо кнопку{' '}
                <span className="fw_600">«Зареєструватися»</span> після чого прграма переведе вас на
                сторінку з меню.
              </div>
            </>
          }
        />
        <AccordionItem
          title=" Чи потрібно буде рахувати калорії?"
          content="Ні, в моїх програмах не потрібно вручну рахувати калорії. Ви отримуєте готове меню з автоматично прорахованою калорійністю, збалансоване за БЖВ (білки, жири, вуглеводи)."
        />
        <AccordionItem
          title="Чи буде індивідуальний підхід?"
          content="Так. Раціон адаптується під індивідуальні потреби вашого організму, стан здоров’я та ритм життя. Також діє автоматична заміна продуктів."
        />
        <AccordionItem
          title="Що, якщо я не люблю якийсь продукт або не маю його вдома?"
          content="У меню передбачена система автоматичних замін: до кожного продукту є кілька альтернатив, тож ви зможете легко адаптувати раціон під себе."
        />
        <AccordionItem
          title="Я не люблю довго готувати. Мені підійде ця програма?"
          content="Так! До кожного прийому їжі я надаю два варіанти страв:
– основний — більш цікавий і смачний, для тих, хто хоче урізноманітнити харчування;
– швидкий — надзвичайно простий, на приготування якого йде мінімум часу.
Ви самі обираєте, який варіант готувати в залежності від свого ритму дня."
        />
        <AccordionItem
          title="Коли будуть перші результати?"
          content="Уже через тиждень ви помітите перші зміни: легкість у тілі, покращення сну, менше набряків, зменшення об'ємів та ваги."
        />
        <AccordionItem
          title="А якщо у мене бракує сили волі?"
          content="Насправді більшість жінок починають саме з цього страху. У програмі є чіткий план, зрозуміле меню та мій супровід в Телегра, де я відповідаю на питання, підтримую, допомагаю розібратись у складних моментах. Це не про жорстку силу волі, а про поступову зміну звичок із підтримкою."
        />
        <AccordionItem
          title="Чи доведеться повністю відмовитись від солодкого?"
          content="Я даю смачні рецепти ПП-десертів — з простих інгредієнтів, які не шкодять фігурі."
        />
        <AccordionItem
          title="У мене є проблеми зі здоров'ям  - можна до вас?"
          content="Я не призначаю лікування, але враховую наявні діагнози, рекомендації лікарів та особливості організму при складанні меню. Якщо є хронічні захворювання — краще повідомити про це перед початком."
        />
        <AccordionItem
          title="Чи буде спортивне навантаження обов'язковим?"
          content="Ні, програма не передбачає обов’язкових тренувань. Якщо ви хочете додати активність — я можу дати загальні поради, як поєднати її з харчуванням."
        />
        <AccordionItem
          title="А якщо я не живу в Україні?"
          content="Моя програма повністю онлайн, тому можна приєднатися з будь-якої країни. Продукти в меню підібрані так, щоб були доступними у більшості регіонів, а також є заміни."
        />
        <AccordionItem
          title="Що від мене буде потрібно?"
          content="Готовність дотримуватись меню, бути відкритою до нових звичок і підтримувати контакт зі мною. Важливо дати собі шанс — зміни починаються з маленьких кроків."
        />
        <AccordionItem
          title="Скільки триває програма?"
          content="Базова програма триває 3 тижні. Цього часу достатньо, щоб побачити перші результати та закласти фундамент нових звичок.
Але на цьому все не закінчується — багато дівчат залишаються зі мною надовго. Після завершення ви можете автоматично переходити в наступну групу та продовжити працювати над тілом, харчуванням і самопочуттям у комфортному темпі, вже з урахуванням свого прогресу."
        />
        <AccordionItem
          title="Чи буде голодно?"
          content="Ні. Раціон збалансований і ситний — голодання та сильні обмеження в моїй практиці не застосовуються. Програма допомагає нормалізувати апетит, а не придушити його."
        />
        <AccordionItem
          title="Я працюю/у мене маленька дитина - чи встигатиму?"
          content="Так! Меню адаптоване під зайнятих жінок: страви прості, інгредієнти доступні, є швидкі варіанти приготування. А також ви отримаєте підтримку — ми знайдемо рішення саме під ваш ритм життя."
        />
        <AccordionItem
          title="Чи потрібно будe купляти дорогі продукти чи добавки?"
          content="Ні. Меню складається зі звичайних продуктів, які можна знайти в найближчому магазині. Додаткові добавки не обов’язкові, і я їх не продаю."
        />
        <AccordionItem
          title="Чи підходить програма мені, якщо я не маю зайвої ваги, але хочу їсти правильно?"
          content="Так. Програма допоможе вибудувати здоровий раціон, стабілізувати апетит, рівень енергії, настрій. Це не лише про схуднення, а й про якість життя."
        />
      </div>
    </section>
  );
}
